import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { EventsCacheLockId } from 'owa-calendar-events-store';

export interface AgendaPane {
    nextCalendarEvent: { id: string; index: number };
    selectedCalendarEventId: string;
    loadingInitialData: boolean;
    eventsCacheLockId: EventsCacheLockId;
}

interface AgendaStore {
    panes: ObservableMap<string, AgendaPane>;
}
const agendaStoreData: AgendaStore = {
    panes: new ObservableMap(),
};

export const getAgendaStore = createStore<AgendaStore>('agendaStore', agendaStoreData);
